// ./componetns/InvitationForm
import React, { useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import {
  TextField,
  Button,
  Radio,
  RadioGroup,
  Box,
  FormControlLabel,
  FormLabel,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/system";
import Title from "./Title";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import Sentence from "./Sentence";
import theme from "../theme";

const FormGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

const InvitationForm = ({
  guests,
  handleChange,
  handleRemoveGuest,
  handleAddGuest,
  handleParticipation,
  loading,
}) => {
  const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] = useState(false);
  const [removeGuestIndex, setRemoveGuestIndex] = useState(0);

  const removeGuestClicked = (index) => {
    setRemoveGuestIndex(index);
    setConfirmDeleteDialogOpen(true);
  };

  const onDeleteInvitee = () => {
    handleRemoveGuest(removeGuestIndex);
    setConfirmDeleteDialogOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ backgroundColor: "#fbf9f3" }} // 背景色を設定
      >
        <Box
          sx={{
            padding: 4,
            display: "inline-block", // コンテンツに合わせて横幅を調整
            textAlign: "center",
            margin: "0 auto", // 親Boxを中央寄せ
          }}
        >
          <Box
            sx={{
              padding: 0,
              width: "100%",
              textAlign: "center",
              borderRadius: 2,
            }}
          >
            <Title size="1.4rem">ゲスト様入力フォーム</Title>

            <Box sx={{ p: 1 }}></Box>

            <Sentence>
              回答期限：7月31日
              <br />
              期限日までなら何度でもご回答を上書き可能です
            </Sentence>
          </Box>

          <Box sx={{ p: 2 }}></Box>

          <Box component="form">
            {guests.map((guest, index) =>
              guest.deleted_flag ? null : (
                <Box key={index}>
                  <Box className="spacer-lg"></Box>
                  <Box className="spacer-lg"></Box>

                  <Grid container spacing={2}>
                    <FormGrid item size={{ xs: 4 }}>
                      <FormLabel
                        htmlFor="last_name first_name"
                        sx={{
                          fontSize: "1.0rem",
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Sentence
                          size="1.2rem"
                          sx={{ marginTop: "10px", marginBottom: "12px" }}
                        >
                          名前*
                        </Sentence>
                      </FormLabel>
                    </FormGrid>
                    <FormGrid item size={{ xs: 4 }}>
                      <TextField
                        label="姓*"
                        id="last_name"
                        name="last_name"
                        value={guest.last_name}
                        onChange={(e) => handleChange(index, e)}
                        fullWidth
                        inputProps={{
                          maxLength: 10,
                          style: { fontFamily: "'KokuGothic', sans-serif" },
                        }}
                        InputLabelProps={{
                          style: { fontFamily: "'KokuGothic', sans-serif" },
                        }}
                      />
                    </FormGrid>
                    <FormGrid item size={{ xs: 4 }}>
                      <TextField
                        label="名*"
                        id="first_name"
                        name="first_name"
                        value={guest.first_name}
                        onChange={(e) => handleChange(index, e)}
                        fullWidth
                        inputProps={{
                          maxLength: 10,
                          style: { fontFamily: "'KokuGothic', sans-serif" },
                        }}
                        InputLabelProps={{
                          style: { fontFamily: "'KokuGothic', sans-serif" },
                        }}
                      />
                    </FormGrid>
                    <FormGrid item size={{ xs: 4 }}>
                      <FormLabel
                        htmlFor="last_name first_name"
                        sx={{
                          fontSize: "1.0rem",
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Sentence
                          size="1.2rem"
                          sx={{ marginTop: "10px", marginBottom: "12px" }}
                        >
                          ふりがな*
                        </Sentence>
                      </FormLabel>
                    </FormGrid>
                    <FormGrid item size={{ xs: 4 }}>
                      <TextField
                        label="せい*"
                        id="last_furigana"
                        name="last_furigana"
                        value={guest.last_furigana}
                        onChange={(e) => handleChange(index, e)}
                        fullWidth
                        inputProps={{
                          maxLength: 10,
                          style: { fontFamily: "'KokuGothic', sans-serif" },
                        }}
                        InputLabelProps={{
                          style: { fontFamily: "'KokuGothic', sans-serif" },
                        }}
                      />
                    </FormGrid>
                    <FormGrid item size={{ xs: 4 }}>
                      <TextField
                        label="めい*"
                        id="first_furigana"
                        name="first_furigana"
                        value={guest.first_furigana}
                        onChange={(e) => handleChange(index, e)}
                        fullWidth
                        inputProps={{
                          maxLength: 10,
                          style: { fontFamily: "'KokuGothic', sans-serif" },
                        }}
                        InputLabelProps={{
                          style: { fontFamily: "'KokuGothic', sans-serif" },
                        }}
                      />
                    </FormGrid>
                    <FormGrid item size={{ xs: 4 }}>
                      <FormLabel
                        htmlFor="allergy"
                        sx={{
                          fontSize: "1.0rem",
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Sentence
                          size="1.2rem"
                          sx={{ marginTop: "10px", marginBottom: "12px" }}
                        >
                          アレルギー
                        </Sentence>
                      </FormLabel>
                    </FormGrid>
                    <FormGrid item size={{ xs: 8 }}>
                      <TextField
                        label="アレルギー"
                        id="allergy"
                        name="allergy"
                        value={guest.allergy}
                        onChange={(e) => handleChange(index, e)}
                        fullWidth
                        inputProps={{
                          maxLength: 100,
                          style: { fontFamily: "'KokuGothic', sans-serif" },
                        }}
                        InputLabelProps={{
                          style: { fontFamily: "'KokuGothic', sans-serif" },
                        }}
                      />
                    </FormGrid>

                    <FormGrid item size={{ xs: 12 }}>
                      <FormLabel
                        htmlFor="will"
                        sx={{
                          fontSize: "1.0rem",
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Sentence
                          size="1.1rem"
                          sx={{ marginTop: "10px", marginBottom: "0px" }}
                        >
                          参加 / 不参加*
                        </Sentence>
                      </FormLabel>
                    </FormGrid>

                    <FormGrid
                      item
                      size={{ xs: 12 }}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <RadioGroup
                        row
                        name="will"
                        value={guest.will}
                        onChange={(e) =>
                          handleChange(index, {
                            target: { name: "will", value: e.target.value },
                          })
                        }
                        required
                        sx={{ gap: 4 }}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label={
                            <Sentence
                              size="1.2rem"
                              sx={{ marginBottom: "0px" }}
                            >
                              参加
                            </Sentence>
                          }
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label={
                            <Sentence
                              size="1.2rem"
                              sx={{ marginBottom: "0px" }}
                            >
                              不参加
                            </Sentence>
                          }
                        />
                      </RadioGroup>
                    </FormGrid>

                    <FormGrid item size={{ xs: 12 }}>
                      <FormLabel
                        htmlFor="sns_permission"
                        sx={{
                          fontSize: "1.0rem",
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Sentence
                          size="1.1rem"
                          sx={{ marginTop: "10px", marginBottom: "0px" }}
                        >
                          あなたが写っている結婚式の写真を私たちのSNSにアップしてもよろしいでしょうか*
                        </Sentence>
                      </FormLabel>
                    </FormGrid>

                    <FormGrid
                      item
                      size={{ xs: 12 }}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <RadioGroup
                        row
                        name="sns_permission"
                        value={guest.sns_permission}
                        onChange={(e) =>
                          handleChange(index, {
                            target: {
                              name: "sns_permission",
                              value: e.target.value,
                            },
                          })
                        }
                        required
                        sx={{ gap: 4 }}
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label={
                            <Sentence
                              size="1.2rem"
                              sx={{ marginBottom: "0px" }}
                            >
                              OK
                            </Sentence>
                          }
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label={
                            <Sentence
                              size="1.2rem"
                              sx={{ marginBottom: "0px" }}
                            >
                              NG
                            </Sentence>
                          }
                        />
                      </RadioGroup>
                    </FormGrid>

                    <FormGrid item size={{ xs: 12 }}>
                      {index > 0 && (
                        <Grid container justifyContent="flex-end">
                          <Grid item>
                            {/* <Button variant="outlined" onClick={() => handleRemoveGuest(index)} startIcon={<RemoveCircleOutlineIcon />}>
                                                    このお連れ様を削除
                                                </Button> */}
                            <Button
                              variant="outlined"
                              onClick={() => removeGuestClicked(index)}
                              startIcon={<RemoveCircleOutlineIcon />}
                            >
                              このお連れ様を削除
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                    </FormGrid>
                  </Grid>
                  <Box sx={{ pb: 12 }} />
                </Box>
              )
            )}
          </Box>

          <FormGrid item xs={12}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Button
                variant="outlined"
                onClick={handleAddGuest}
                startIcon={<AddCircleOutlineIcon />}
                disabled={guests.length >= 10}
              >
                お連れ様を追加
              </Button>
              <Button
                variant="contained"
                type="button"
                onClick={handleParticipation}
              >
                送信
              </Button>
            </Box>
          </FormGrid>

          <Dialog
            open={confirmDeleteDialogOpen}
            onClose={() => setConfirmDeleteDialogOpen(false)}
          >
            <DialogTitle>削除確認</DialogTitle>
            <DialogContent>
              <Typography variant="body1">
                このお連れ様を削除しますか？
              </Typography>
            </DialogContent>
            <DialogActions>
              <Stack direction="row" sx={{ mr: 2, mb: 2 }} spacing={1}>
                <Button
                  variant="contained"
                  onClick={() => setConfirmDeleteDialogOpen(false)}
                  color="secondary"
                >
                  キャンセル
                </Button>
                <Box sx={{ position: "relative" }}>
                  <Button
                    variant="contained"
                    onClick={onDeleteInvitee}
                    disabled={loading}
                    color="primary"
                  >
                    削除
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: green[500],
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </Box>
              </Stack>
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default InvitationForm;
